import React, { useState } from 'react';
import '../assets/styles/UserGuide.css';
import '../assets/styles/EarlyAccess.css';
import '../assets/styles/LandingLayout.css';
import { Link } from 'react-router-dom';

const Help = () => {
  const [activeCategory, setActiveCategory] = useState('gettingStarted');

  // FAQ categories and questions
  const faqCategories = {
    gettingStarted: {
      title: 'Getting Started',
      questions: [
        {
          q: 'How do I create a profile?',
          a: 'Click on "Set Up Profile" in the navigation menu or on the homepage. You\'ll be prompted to enter your name, year level, select your textbook, and share information about your confidence level in mathematics.'
        },
        {
          q: 'Which textbooks are supported?',
          a: 'We currently support NSW Year 11 Standard Cambridge, (with Pearson, Oxford, and Maths in Focus textbooks coming soon for Year NSW). You can also use the app in general if your specific textbook is not listed, or try out the homework help page. As we expand, we\'ll add more textbooks and resources.'
        },
        {
          q: 'How do I start a tutoring session?',
          a: 'After setting up your profile, click on "Start a Session" from the homepage or navigation menu. You\'ll be able to select specific modules and choose a learning mode that suits your needs.'
        }
      ]
    },
    tutorSessions: {
      title: 'Tutor Sessions',
      questions: [
        {
          q: 'What are the different learning modes?',
          a: '"Get the Basics" provides step-by-step guidance for fundamental understanding, "Revision" helps you practice concepts you\'ve already learned, and "Become an Expert" challenges you with advanced problems and concepts.'
        },
        {
          q: 'Can I upload images of my math problems?',
          a: 'Yes! During a tutor session, you can click the "Upload Image" button (or drag and drop) in the input area to upload a picture of your math problem or handwritten work.'
        },
        {
          q: 'How does the visual zone work?',
          a: 'The visual zone displays interactive graphs, equations, and diagrams to help you understand mathematical concepts. The AI tutor will generate these visuals as needed during your learning session.'
        }
      ]
    },
    accounts: {
      title: 'Accounts & Billing',
      questions: [
        {
          q: 'Is there a free plan available?',
          a: 'We don\'t offer a free plan, but you can watch our comprehensive demo video on the home page to see the AI Maths Tutor in action before signing up.'
        },
        {
          q: 'How do I change my profile information?',
          a: 'You can update your profile information by clicking on your name in the top-right corner and selecting "Edit Profile".'
        }
      ]
    },
    technical: {
      title: 'Technical Help',
      questions: [
        {
          q: 'The app is running slowly. What can I do?',
          a: 'Try refreshing the page or clearing your browser cache. If problems persist, try using a different browser or contact our support team.'
        },
        {
          q: 'How can I report a bug or issue?',
          a: 'If you encounter any issues or bugs, please visit our Contact page and submit a detailed description of the problem you\'re experiencing.'
        }
      ]
    }
  };

  return (
    <div className="app-background-pattern">
      <div className="early-access-content">
        <div className="hero-section">
          <h1>
            User <span className="gradient-text">Guide</span>
          </h1>
          <p className="hero-subtitle">Find answers to common questions and learn how to use AI Maths Tutor</p>
        </div>
        
        <div className="help-content">
          <div className="help-sidebar">
            <h3>Categories</h3>
            <ul className="category-list">
              {Object.keys(faqCategories).map(categoryKey => (
                <li 
                  key={categoryKey} 
                  className={activeCategory === categoryKey ? 'active' : ''}
                  onClick={() => setActiveCategory(categoryKey)}
                >
                  {faqCategories[categoryKey].title}
                </li>
              ))}
            </ul>
            
            <div className="help-contact">
              <h3>Need More Help?</h3>
              <p>Our support team is here for you.</p>
              <Link to="/contact" className="btn btn-primary">Contact Support</Link>
            </div>
          </div>
          
          <div className="help-main">
            <h2>{faqCategories[activeCategory].title}</h2>
            
            <div className="faq-list">
              {faqCategories[activeCategory].questions.map((faq, index) => (
                <div className="faq-item" key={index}>
                  <h3>{faq.q}</h3>
                  <p>{faq.a}</p>
                </div>
              ))}
            </div>
            
            {activeCategory === 'gettingStarted' && (
              <div className="quick-links">
                <h3>Helpful Resources</h3>
                <div className="resource-links">
                  <Link to="/setup" className="resource-link">
                    <div className="resource-icon">🔧</div>
                    <div className="resource-text">
                      <h4>Set Up Your Profile</h4>
                      <p>Get started with personalized tutoring</p>
                    </div>
                  </Link>
                  <Link to="/" className="resource-link">
                    <div className="resource-icon">🎥</div>
                    <div className="resource-text">
                      <h4>Watch Demo Video</h4>
                      <p>See AI Maths Tutor in action on our home page</p>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
